import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import "./FaqPage.style.css";
import { useState } from "react";
import { faqs } from "./faqs";


const FaqPage = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";

  const [open, setOpen] = useState({}); // {0:true, 3:true, ...}
  const toggle = (i) => setOpen((prev) => ({ ...prev, [i]: !prev[i] }));

  // Yardımcı: objelerde TR/EN seç
  const pick = (obj) => (obj && (obj[L] ?? obj.en)) ?? "";

  // Cevabı render et: string (HTML destekli) | {before,label,href,after}
  const renderAnswer = (ans) => {
    if (ans == null) return null;

    // 1) Obje formatı: { before, label, href, after }
    if (typeof ans === "object" && !Array.isArray(ans)) {
      const { before = "", label = "", href = "", after = "" } = ans;
      return (
        <p className="faq-atext">
          {before}
          {href ? (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {label || href}
            </a>
          ) : (
            label
          )}
          {after}
        </p>
      );
    }

    // 2) Düz string: HTML içerebilir (ör. <a href="...">buradan</a>)
    if (typeof ans === "string") {
      return <p className="faq-atext" dangerouslySetInnerHTML={{ __html: ans }} />;
    }

    // 3) Listeler vs. gelirse fallback
    return <p className="faq-atext">{String(ans)}</p>;
  };

  return (
    <div>
      <Meta title={t("faq")} description={t("faq")} lang={lang} />
      <Navbar />

      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("faq")}
              </h1>
            </div>
          </div>
        </div>

        {/* İçerik */}
        <div className="po-container">
          <InvestorSidebar />

          <main className="pol-content">
            <section className="pol-card">
              <ul className="faq-list" role="list">
                {faqs.map((item, i) => {
                  const isOpen = !!open[i];
                  const panelId = `faq-panel-${i}`;
                  const btnId = `faq-btn-${i}`;
                  const qText = pick(item.q);
                  const aVal = pick(item.a);

                  return (
                    <li key={i} className={`faq-item ${isOpen ? "is-open" : ""}`}>
                      <button
                        id={btnId}
                        className="faq-q"
                        aria-expanded={isOpen}
                        aria-controls={panelId}
                        onClick={() => toggle(i)}
                      >
                        <span className="faq-sign" aria-hidden="true">{isOpen ? "−" : "+"}</span>
                        <span className="faq-qtext">
                          <span className="faq-number">{i + 1}-</span>{" "}
                          {qText}
                        </span>
                      </button>

                      <div
                        id={panelId}
                        className={`faq-a ${isOpen ? "is-open" : ""}`}
                        role="region"
                        aria-labelledby={btnId}
                      >
                        {renderAnswer(aVal)}
                      </div>
                    </li>
                  );
                })}
              </ul>
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default FaqPage;
